





















import Vue from 'vue'
import moment from 'moment'
import { UserProfile } from '@/types/users'
import './SingleMessage.scss'

export default Vue.extend({
  name: 'SingleMessage',
  props: {
    message: {
      type: String,
      required: true
    },
    authorId: {
      type: String,
      required: true
    },
    author: {
      type: Object as () => UserProfile,
      required: true
    },
    avatar: {
      type: String,
      required: false,
      default: ''
    },
    timestamp: {
      required: false, // set by Firestore on server (so is null at first)
      type: Object
    },
    isAuthor: {
      type: Boolean,
      required: true
    },
    authorColor: {
      type: String,
      required: true
    },
    authorTextColor: {
      type: String,
      required: true
    },
    defaultColor: {
      type: String,
      required: true
    },
    defaultTextColor: {
      type: String,
      required: true
    },
    showTimestamp: {
      type: Boolean,
      required: false,
      default: true
    },
    mini: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: () => ({
    moment: moment
  }),
  computed: {
    haveAuthor (): boolean {
      return Object.keys(this.author).length > 0
    },
    authorName (): string {
      const firstName = this.author.first_name !== undefined ? this.author.first_name : ''
      const lastName = this.author.last_name !== undefined ? this.author.last_name : ''
      return this.haveAuthor ? (firstName + ' ' + lastName) : 'Kiswe Support'
    }
  },
  methods: {
    getBgStyle (): Partial<CSSStyleDeclaration> {
      return `background-color: ${this.authorColor}`
    },
    getTextStyle (): Partial<CSSStyleDeclaration> {
      let styles = ''
      if (this.isAuthor) {
        styles = `color: ${this.authorTextColor}`
      } else {
        styles = `color: ${this.defaultTextColor}`
      }
      return styles
    },
    authorSelected () {
      this.$emit('authorSelected', this.authorId)
    },
    getInitials (author: UserProfile) {
      const firstInitial = author.hasOwnProperty('first_name') ? author.first_name.charAt(0).toUpperCase() : ''
      const lastInitial = author.hasOwnProperty('last_name') ? author.last_name.charAt(0).toUpperCase() : ''
      return firstInitial + lastInitial
    }
  }
})
